export default __webpack_public_path__ + "static/media/fondo.13cd82db.jpg";